// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-solidity-contract-dialog[data-v-2cc2c67f] .el-dialog{width:var(--common-dialog-large-width)}.add-solidity-contract-dialog .alert-info[data-v-2cc2c67f]{margin-bottom:var(--base-size-20);width:90%;margin-left:5%}.add-solidity-contract-dialog .el-form[data-v-2cc2c67f]{margin-right:var(--base-size-48)}", ""]);
// Exports
module.exports = exports;
